import {
  Field,
  makeStyles,
  SpinButton,
  Switch,
  tokens,
} from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { MemoEdit, Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useState } from 'react';

// Localization namespace — reuses the Blazor demo's
// `MemoEditPropertiesDemo` keys so both stacks read from the same JSON.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Editors.MemoEdit.MemoEditPropertiesDemo';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalL,
  },
  inlineField: {
    flexShrink: 0,
    gridTemplateColumns: 'auto auto',
    '& label': {
      whiteSpace: 'nowrap',
    },
  },
  numberInput: {
    width: '85px',
  },
});

export function MemoEditPropertiesSample() {
  const styles = useStyles();
  const t = useT();
  const [readOnly, setReadOnly] = useState(false);
  const [required, setRequired] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [rows, setRows] = useState(3);
  const [minLength, setMinLength] = useState(10);
  const [maxLength, setMaxLength] = useState(1000);

  return (
    <Section>
      <SectionColumn
        header={
          <div className={styles.toolbar}>
            <Switch
              label={t(`${STRINGS_BASE}.readonly`)}
              labelPosition="before"
              checked={readOnly}
              onChange={(_, d) => setReadOnly(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.required`)}
              labelPosition="before"
              checked={required}
              onChange={(_, d) => setRequired(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.disabled`)}
              labelPosition="before"
              checked={disabled}
              onChange={(_, d) => setDisabled(d.checked)}
            />
            <Field
              label={t(`${STRINGS_BASE}.num-rows`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                min={1}
                value={rows}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setRows(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.min-length`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                min={0}
                value={minLength}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setMinLength(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.max-length`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                value={maxLength}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setMaxLength(n);
                }}
              />
            </Field>
          </div>
        }
      >
        <div style={{ maxWidth: '320px' }}>
          <MemoEdit
            columnName="ppp_description"
            required={required}
            readOnly={readOnly}
            disabled={disabled}
            rows={rows}
            minLength={minLength}
            maxLength={maxLength}
            style={{ minWidth: 300 }}
          />
        </div>
      </SectionColumn>
    </Section>
  );
}
